import React, { memo } from 'react';
import PropTypes from 'prop-types';

const StatusColumn = memo(({ feed, handleToggle }) => (
  <td>
    <label className="custom-toggle ms-auto me-auto">
      <input type="checkbox" name="status" checked={feed.status} onChange={handleToggle} />
      <span className="custom-toggle-slider rounded-circle" />
    </label>
  </td>
));

StatusColumn.propTypes = {
  feed: PropTypes.object.isRequired,
  handleToggle: PropTypes.func.isRequired
};

export default StatusColumn;